'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _module = require('./mixins/module');

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartGifts = function (_Module) {
  (0, _inherits3.default)(CartGifts, _Module);

  /** @param {HTMLElement} element */
  function CartGifts(element) {
    (0, _classCallCheck3.default)(this, CartGifts);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartGifts.__proto__ || (0, _getPrototypeOf2.default)(CartGifts)).call(this, element));

    _this.carousel = null;

    _this.els = {
      element: element,
      body: _this.getChildElement('body'),
      carousel: _this.getChildElement('carousel'),
      toggle: _this.getChildElement('toggle'),
      nextArrow: _this.getChildElement('next-arrow'),
      previousArrow: _this.getChildElement('previous-arrow')
    };

    _this.isOpen = element.getAttribute('aria-expanded') === 'true';

    _this.setupListeners();
    return _this;
  }

  (0, _createClass3.default)(CartGifts, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      this.els.toggle.addEventListener('click', function () {
        _this2.isOpen = !_this2.isOpen;
      });

      this.els.nextArrow.addEventListener('click', function () {
        _this2.carousel && _this2.carousel.next();
      });

      this.els.previousArrow.addEventListener('click', function () {
        _this2.carousel && _this2.carousel.previous();
      });
    }
  }, {
    key: 'setupCarousel',
    value: function setupCarousel() {
      this.carousel = new _flickity2.default(this.els.carousel, {
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true
      });
    }

    /**
     * @param {string} name
     * @returns Element
     */

  }, {
    key: 'getChildElement',
    value: function getChildElement(name) {
      return this.getContextElement('[data-el="cart-gifts.' + name + '"]');
    }

    /**
     * @param {string} name
     * @returns Element[]
     */

  }, {
    key: 'getChildElements',
    value: function getChildElements(name) {
      return this.getContextElements('[data-el="cart-gifts.' + name + '"]');
    }
  }, {
    key: 'isOpen',
    get: function get() {
      return this.els.element.getAttribute('aria-expanded') === 'true';
    },
    set: function set(isOpen) {
      this.els.element.setAttribute('aria-expanded', isOpen);

      if (isOpen && !this.carousel) {
        this.setupCarousel();
      }
    }
  }]);
  return CartGifts;
}(_module2.default);

exports.default = CartGifts;